import styled from 'styled-components';
import { Anchor } from '@klaviyo-mkt/gatsby-components/atoms/anchor';
import SubcategoryCard from '@klaviyo-mkt/gatsby-components/molecules/subcategory-card';
import Typography from '@klaviyo-mkt/gatsby-components/atoms/typography';
import TopicsMenuWithData from '../../../components/topics-menu';

export const CategoryPage = styled.div``;

export const CategoryName = styled(Typography)`
  display: none;

  ${({ theme }) => `
    ${theme.screenSize.s1024.mediaQuery} {
      display: block;
    }
  `}
`;

export const CategoryDescription = styled(Typography)``;

export const CategoryMeta = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  margin-bottom: 3.2rem;
`;

export const Sections = styled.div`
  display: grid;
  gap: 2.4rem;
  justify-content: center;
  padding: 0 3.6rem;
  
  ${({ theme }) => `
    ${theme.screenSize.s1024.mediaQuery} {
      grid-template-columns: repeat(3, minmax(0, 1fr));
      padding: 0;
    }
  `}
`;

export const TopArticleHeadline = styled(Typography)`
  padding-top: 7.2rem;
  padding-bottom: 2.4rem;
`;

export const TopArticle = styled(Anchor)`
  color: ${({ theme }) => theme.colors.charcoal};
  font-size: 1.8rem;
  text-underline-offset: 0.1em;

  &:hover {
    color: ${({ theme }) => theme.colors.charcoal};
  }
`;

export const TopArticleList = styled.li`
  margin-bottom: 3.2rem;
`;

export const TopArticleUl = styled.ul`
  list-style-type: none;
  padding: 0;
`;

export const StyledTopicsMenu = styled(TopicsMenuWithData)``;

export const Content = styled.div``;

export const Section = styled(SubcategoryCard)``;
